import { useEffect, useState } from 'react';
import { Button } from '@vinted/web-ui';
import { GOOGLE_OAUTH_URL } from 'constants/routes';
import useTranslate from 'hooks/useTranslate';
import { urlWithParams, getNormalizedQueryParam } from 'libs/utils/url';
import { getGoogleIdToken } from 'data/api';
import { decodeJwt } from 'libs/utils/authentication';
import { getRelativeUrl } from 'libs/utils/window';
import { getGoogleRedirectUrl } from 'libs/utils/google';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import useTracking from 'hooks/useTracking';
import useSuccessUrl from '../hooks/useSuccessUrl';
import { jsx as _jsx } from "react/jsx-runtime";

const GoogleOauthButton = _ref => {
  let {
    onSuccess,
    onFailure
  } = _ref;
  const {
    0: isLoggingIn,
    1: setIsLoggingIn
  } = useState(false);
  const translate = useTranslate('auth.select_type');
  const code = getNormalizedQueryParam('code');
  const state = getNormalizedQueryParam('state');
  const redirectUrl = getGoogleRedirectUrl(state);
  const successUrl = useSuccessUrl(getRelativeUrl());
  const {
    track
  } = useTracking();
  const oauthUrl = urlWithParams(GOOGLE_OAUTH_URL, {
    redirect_uri: successUrl
  });
  useEffect(() => {
    if (!code || !state || isLoggingIn) return;

    const fetchGoogleToken = async () => {
      const response = await getGoogleIdToken({
        code,
        state
      });

      if ('errors' in response) {
        onFailure();
        return;
      }

      const {
        id_token: token
      } = response;
      const {
        email,
        name
      } = decodeJwt(token);
      onSuccess({
        token,
        fields: {
          name,
          email
        },
        redirectUrl
      });
    };

    setIsLoggingIn(true);
    fetchGoogleToken();
  }, [code, isLoggingIn, redirectUrl, state, onSuccess, onFailure]);

  const handleClick = () => {
    setIsLoggingIn(true);
    track(clickEvent({
      target: ClickableElement.LoginWithGoogle
    }));
  };

  return /*#__PURE__*/_jsx(Button, {
    theme: "amplified",
    iconName: "signup/google",
    onClick: handleClick,
    url: oauthUrl,
    isLoading: isLoggingIn,
    text: translate('actions.google')
  });
};

export default GoogleOauthButton;